// extracted by mini-css-extract-plugin
export default {"portal-root":"PortalToTable_portal-root__A43OC","portalRoot":"PortalToTable_portal-root__A43OC"};